<template>
  <div>
    <viewTable
        ref="viewTable"
        :limits="limits"
        :columns-property="columnsProperty"
        :filter="filter"
        module="basic"
        url="inStockBills"
        @addOrEdit="addEditHandle"
        @delete="deleteHandle"
        @reset="resetHandle"
        @select="selectHandle"
    >
      <template slot="otherBtn">
        <el-button v-if="limits.exportAuth" type="primary" :loading="exportLoading" @click="exportHandle">导出</el-button>
        <el-button v-if="limits.submitAuth" type="primary" :disabled="!selection.length" @click="submitHandle">
          提交
        </el-button>
        <el-button v-if="limits.cancelAuth" type="primary" :disabled="!selection.length" @click="repealHandle">
          撤销
        </el-button>
        <el-button v-if="limits.printAuth" type="primary" :disabled="!selection.length" @click="printInStockOrder">
          打印入库单
        </el-button>
      </template>
      <template slot="actionBtn" slot-scope="scope">
        <el-button v-if="limits.postAuth" :disabled="scope.row.statusName === '全部入库' || scope.row.statusName==='未提交'" type="success" @click="post(scope.row)"> 过账</el-button>
        <!--        <el-button v-if="limits.postAuth" scope.row.statusName === '已入库'" type="success" @click="post(scope.row)"> 过账</el-button>-->
      </template>

      <template slot="adSearch">
        <el-form :inline="true" :model="filter" @keyup.enter.native="loadData(1)">
          <el-form-item label="入库单号">
            <el-input v-model.trim="filter.billNo" placeholder="请输入入库单号" clearable/>
          </el-form-item>
          <el-form-item label="入库类型">
            <el-select v-model="filter.inStockType" placeholder="请选择入库类型" clearable>
              <el-option label="生产入库" :value="1"/>
              <el-option label="生产退料" :value="4"/>
              <el-option label="客供入库" :value="8"/>
              <el-option label="副产品入库" :value="9"/>
              <el-option label="委外退料" :value="10"/>
              <el-option label="超领退料" :value="11"/>
            </el-select>
          </el-form-item>
          <el-form-item label="入库状态">
            <el-select v-model="filter.status" placeholder="请选择入库状态" clearable>
              <el-option label="未提交" :value="0"/>
              <el-option label="已提交" :value="1"/>
              <el-option label="已打印" :value="3"/>
              <el-option label="部分入库" :value="5"/>
              <el-option label="全部入库" :value="2"/>
            </el-select>
          </el-form-item>
          <el-form-item label="关联单据">
            <el-input v-model.trim="filter.relBillNo" placeholder="请输入关联单据编号" clearable/>
          </el-form-item>
          <el-form-item label="创建日期">
            <el-date-picker
                v-model="createTimeDate"
                type="daterange"
                value-format="yyyy-MM-dd"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                @change="handleTimeDateChange"
            />
          </el-form-item>
          <el-form-item label="过账日期">
            <el-date-picker
                v-model="postTimeDate"
                type="daterange"
                value-format="yyyy-MM-dd"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                @change="postTimeDateChange"
            />
          </el-form-item>
          <el-form-item label="物料号">
            <el-input v-model.trim="filter.materialNo" placeholder="请输入物料号" clearable/>
          </el-form-item>
        </el-form>
      </template>
    </viewTable>

    <!-- 新建编辑 -->
    <storage-order-edit ref="storageOrderEdit" @save-success="loadData"/>
  </div>
</template>

<script>
  import viewTable from "@/components/ViewTable.vue";
  import StorageOrderEdit from "./StorageOrderEdit";

  export default {
    name: "StorageOrder",
    components: {viewTable, StorageOrderEdit},
    data() {
      return {
        limits: {
          addAuth: this.$auth(532),
          editAuth: this.$auth(536),
          delAuth: this.$auth(538),
          submitAuth: this.$auth(533),
          cancelAuth: this.$auth(534),
          printAuth: this.$auth(535),
          postAuth: this.$auth(537),
          exportAuth:this.$auth(67),
        },
        receiptDate: "", // 到货日期
        postTimeDate: "",
        createTimeDate: "",
        selection: [],
        exportLoading: false,
        filter: {
          billNo: "",
          inStockType: "",
          status: "",
          relBillNo: "",
          receiptDateFrom: "",
          receiptDateTo: "",
          postTimeBegin: "",
          postTimeEnd: "",
          createDateFrom:"",
          createDateTo:"",
        },
        columnsProperty: [
          {
            tooltip: true,
            key: "billNo",
            width: 140,
            align: "center",
            render: (h, params) => {
              return h(
                "span",
                {
                  style: {
                    color: "#2d8cf0",
                    cursor: "pointer",
                  },
                  on: {
                    click: () => {
                      this.$refs.storageOrderEdit.open(params.row, true);
                    },
                  },
                },
                params.row.billNo,
              );
            },
          },
          {
            tooltip: true,
            key: "inStockTypeName",
            width: 100,
            align: "center",
          },
          {
            tooltip: true,
            key: "statusName",
            width: 100,
            align: "center",
          },
          {
            tooltip: true,
            key: "relBillNo",
            width: 140,
            align: "center",
          },
          {
            tooltip: true,
            key: "receiptDate",
            width: 160,
            align: "center",
          },
          {
            tooltip: true,
            key: "creatorName",
            width: 100,
            align: "center",
          },
          {
            tooltip: true,
            key: "createTime",
            width: 160,
            align: "center",
          },
          {
            tooltip: true,
            key: "note",
            minWidth: 150,
          },
          {
            key: "action",
            align: "center",
            width: 220,
            slot: "action",
            fixed: "right",
          },
        ],
      };
    },
    methods: {
      // 查询入库单列表
      loadData(pageNum) {
        this.selection = [];
        this.$refs.viewTable.loadData(pageNum);
      },

      // 新建 编辑
      addEditHandle(row) {
        this.$refs.storageOrderEdit.open(row);
      },
      post(row) {
        this.$refs.storageOrderEdit.open(row, null, true);
      },

      // 只能编辑删除未提交的入库单
      otherAuth: (row) => {
        return !!row.status;
      },

      // 删除
      deleteHandle(row) {
        this.$http.delete("basic", "inStockBills", row.pkid).then((resp) => {
          if (resp.success) {
            this.$message.success("删除成功");
            this.loadData();
          }
        });
      },

      receiptDateChange(date) {
        if (date) {
          this.filter.receiptDateFrom = date[0];
          this.filter.receiptDateTo = date[1];
        } else {
          this.filter.receiptDateFrom = "";
          this.filter.receiptDateTo = "";
        }
      },
      handleTimeDateChange(date) {
        if (date) {
          this.filter.createDateFrom = date[0];
          this.filter.createDateTo = date[1];
        } else {
          this.filter.handleTimeBegin = "";
          this.filter.handleTimeEnd = "";
        }
      },
      postTimeDateChange(date) {
        if (date) {
          this.filter.postTimeBegin = date[0];
          this.filter.postTimeEnd = date[1];
        } else {
          this.filter.postTimeBegin = "";
          this.filter.postTimeEnd = "";
        }
      },

      selectHandle(selection) {
        this.selection = selection;
      },

      // 提交
      submitHandle() {
        const arr = this.selection.filter((item) => item.status !== 0);
        if (arr.length) {
          this.$confirm("请选择未提交的入库单", "错误", {
            type: "error",
            showCancelButton: false,
          });
        } else {
          let ids = [];
          this.selection.forEach((item) => {
            ids.push(item.pkid);
          });
          this.$confirm("确认提交吗?", "提示", {type: "warning"}).then(() => {
            this.$http.post("basic", "inStockBills/submit", ids).then(() => {
              this.$message.success("提交成功");
              this.loadData();
            });
          });
        }
      },

      // 撤销
      repealHandle() {
        let ids = [];
        this.selection.forEach((item) => {
          ids.push(item.pkid);
        });
        this.$confirm("确认撤销吗?", "提示", {type: "warning"}).then(() => {
          this.$http.post("basic", "inStockBills/cancel", ids).then(() => {
            this.$message.success("撤销成功");
            this.loadData();
          });
        });
      },

      // 打印入库单
      printInStockOrder() {
        let ids = [];
        this.selection.forEach((item) => {
          ids.push(item.pkid);
        });
        this.upDataPrintStatus(ids);
        const routeUrl = this.$router.resolve({
          path: "/storageOrderPrint",
          query: {
            params: ids,
          },
        });
        window.open(routeUrl.href, "_blank");
      },
      upDataPrintStatus(ids) {
        this.$http.post("basic", "inStockBills/print", ids).then((resp) => {
          if (resp.success) {
            this.$message.success("打印状态修改成功");
          } else {
            this.$message.error("打印状态修改失败");
          }
        }).catch(() => {
          this.$message.error("打印状态修改失败");
        });
      },
      // 重置
      resetHandle(filter) {
        this.filter = Object.assign(this.filter, filter);
        this.receiptDate = "";
      },

      // 导出处理
      exportHandle() {
        this.exportLoading = true;
        let params = Object.assign({}, this.filter);
        this.$http.exportExcel("basic", "inStockBills/export", params)
          .then((res) => {
            // const blob = new Blob([res.data]);
            // const downloadElement = document.createElement("a");
            // const href = window.URL.createObjectURL(blob);
            // const contentDisposition = res.headers["content-disposition"];
            // let fileName = "导出数据";
            // if (contentDisposition) {
            //   fileName = decodeURI(contentDisposition.split("filename*=utf-8''")[1].split(".")[0]);
            // }
            // downloadElement.style.display = "none";
            // downloadElement.href = href;
            // downloadElement.download = fileName + ".xls"; // 下载后文件名
            // document.body.appendChild(downloadElement);
            // downloadElement.click(); // 点击下载
            // document.body.removeChild(downloadElement); // 下载完成移除元素
            // window.URL.revokeObjectURL(href); // 释放掉blob对象
            // 创建Blob对象
            const blob = new Blob([res.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });

            // 创建下载链接
            const link = document.createElement("a");
            const url = window.URL.createObjectURL(blob);

            // 设置下载文件名
            const fileName = `入库单明细数据_${new Date().toLocaleDateString().replace(/\//g, "-")}.xlsx`;
            link.href = url;
            link.download = fileName;

            // 触发下载
            document.body.appendChild(link);
            link.click();

            // 清理
            setTimeout(() => {
              document.body.removeChild(link);
              window.URL.revokeObjectURL(url);
            }, 100);

            this.$message.success("导出成功");
          })
          .catch(() => {
            this.exportLoading = false;
            this.$message.error("导出失败");
          })
          .finally(() => {
            this.exportLoading = false;
          });
      },
    },
  };
</script>
